import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { isNullOrUndefined } from 'util';
import { Contrato } from '../modelo/contrato';
import { DebitoAutomaticoContratoDados } from '../modelo/debito-automatico-contrato-dados';
import { DebitoAutomaticoContratoDetalhe } from '../modelo/debito-automatico-contrato-detalhe';
import { Config } from '../services/config';
import { DebitoAutomaticoService } from '../services/debitoautomatico.service';
import { MensagemService } from '../services/mensagem.service';
import { RestClientService } from '../services/restclient.service';
import { SegundaViaService } from '../services/segundavia.service';
import { SessaoService } from '../services/sessao.service';
import { AbstractComponent } from '../util/abstract.component';
import { DebitoAutomaticoContratoModalComponent } from './debito-automatico-contrato-modal.component';

declare var $: any;

@Component({
  selector: 'app-debito-automatico-contrato',
  templateUrl: './debito-automatico-contrato.component.html',
  styleUrls: ['./debito-automatico.component.css'],
  providers: [SegundaViaService, DebitoAutomaticoService, MensagemService, RestClientService]
})
export class DebitoAutomaticoContratoComponent extends AbstractComponent implements OnInit {

  debitoAutomaticoContratoDetalhe: DebitoAutomaticoContratoDetalhe = new DebitoAutomaticoContratoDetalhe();
  debitoAutomaticoContratoDados: DebitoAutomaticoContratoDados = new DebitoAutomaticoContratoDados();
  contrato: Contrato = new Contrato();

  optinLimite: string = "";
  optinVencida: string = "";

  isOptinLimiteSimSelected: boolean = false;
  isOptinLimiteNaoSelected: boolean = false;

  isOptinVencidaSimSelected: boolean = false;
  isOptinVencidaNaoSelected: boolean = false;

  constructor(
    private sessaoService: SessaoService,
    private mensagemService: MensagemService,
    private router: Router,
    private spinnerService: Ng4LoadingSpinnerService,
    private debitoAutomaticoService: DebitoAutomaticoService,
    public dialog: MatDialog) {
    super(sessaoService);
  }

  ngOnInit() {

    //Scroll top
    window.scrollTo(0, 0);
    this.debitoAutomaticoContratoDetalhe = JSON.parse(sessionStorage.getItem('debitoAutomaticoContratoDetalhe'));
    this.contrato = JSON.parse(sessionStorage.getItem('debitoAutomaticoContrato')) || new Contrato();
    this.optinLimite = this.debitoAutomaticoContratoDetalhe.optinLimite;
    this.optinVencida = this.debitoAutomaticoContratoDetalhe.optinVencida;
    this.defineSelectedOptins();
    
    // Buscar dados atualizados do service
    this.consultarContratoDebitoAutomatico();
    this.consultarDadosContrato();

    // Close Menu Mobile
    var isMobile = window.matchMedia("only screen and (max-width: 760px)");
    $(".content").click(function () {
      if (isMobile.matches) {
        $(".page").removeClass("toggled");
      }
    });



  }

  chooseOptinLimite($event: any) {
    this.optinLimite = $event.target.value === 'sim' ? 'S' : 'N';
    this.defineSelectedOptins();
  }

  chooseOptinVencida($event: any) {
    this.optinVencida = $event.target.value === 'sim' ? 'S' : 'N';
    this.defineSelectedOptins();
  }

  defineSelectedOptins() {
    this.isOptinLimiteSimSelected = !isNullOrUndefined(this.optinLimite) && this.optinLimite !== "" && this.optinLimite === 'S';
    this.isOptinLimiteNaoSelected = !isNullOrUndefined(this.optinLimite) && this.optinLimite !== "" && this.optinLimite === 'N';

    this.isOptinVencidaSimSelected = !isNullOrUndefined(this.optinVencida) && this.optinVencida !== "" && this.optinVencida === 'S';
    this.isOptinVencidaNaoSelected = !isNullOrUndefined(this.optinVencida) && this.optinVencida !== "" && this.optinVencida === 'N';
  }

  consultarContratoDebitoAutomatico(): void {
    if (this.debitoAutomaticoContratoDetalhe && this.debitoAutomaticoContratoDetalhe.nuContrato) {
      const contrato: Contrato = new Contrato();
      contrato.nuContrato = this.debitoAutomaticoContratoDetalhe.nuContrato;
      
      this.debitoAutomaticoService.consultarContratoDebitoAutomatico(contrato).subscribe(
        (result: DebitoAutomaticoContratoDetalhe) => {
          if (result.cdMsgemRetorno == "0") {
            this.optinLimite = result.optinLimite;
            this.optinVencida = result.optinVencida;
            this.defineSelectedOptins();
            this.spinnerService.hide();
          }
        },
        (error: Response) => {
          console.error('Erro na chamada do service:', error);
          this.spinnerService.hide();
        }
      );
    }
  }

  consultarDadosContrato(): void {
    if (this.debitoAutomaticoContratoDetalhe && this.debitoAutomaticoContratoDetalhe.nuContrato) {
      const contrato: Contrato = new Contrato();
      contrato.nuContrato = this.debitoAutomaticoContratoDetalhe.nuContrato;

      this.debitoAutomaticoService.consultarDadosContrato(contrato).subscribe(
        (result: DebitoAutomaticoContratoDados) => {
          this.spinnerService.hide();

          if (result.cdMsgemRetorno == "0" || result.cdMsgemRetorno == null) {
            this.debitoAutomaticoContratoDados = result;
          }
        },
        (error: Response) => {
          console.error('Erro na chamada do service:', error);
          this.spinnerService.hide();
        }
      );
    }
  }

  modalConfirmar(): void {
    this.dialog.open(DebitoAutomaticoContratoModalComponent, {
      width: Config.POPUP_100VW,
      data: {
        debitoAutomaticoContratoDetalhe: this.debitoAutomaticoContratoDetalhe,
        optinLimite: this.optinLimite,
        optinVencida: this.optinVencida
      }
    });
  }

}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/debito-automatico/debito-automatico-contrato.component.ts